import { API_ORIGIN } from '../../config'
// Elementos de navegación compartidos por el sidebar y la barra inferior del portal del inquilino.
export const UPLOADS_BASE = `${API_ORIGIN}/uploads`

export function parkLogoSrc(logoUrl) {
  return logoUrl ? `${UPLOADS_BASE}/${logoUrl}` : ''
}

// "Resumen" solo aparece con 2 o más contratos visibles (suma todas sus naves).
// "Mis solicitudes" solo aparece si el administrador habilitó las solicitudes de mantenimiento.
export function tenantNavItems(sections, contractCount = 0) {
  const items = []
  if (contractCount > 1) {
    items.push({ label: 'Resumen', short: 'Resumen', icon: 'mdi-view-dashboard-outline', to: '/inquilino/resumen', match: (p) => p.startsWith('/inquilino/resumen') })
  }
  items.push(
    { label: 'Mi contrato', short: 'Contrato', icon: 'mdi-file-document-outline', to: '/inquilino', match: (p) => p === '/inquilino' },
    { label: 'Mis pagos', short: 'Pagos', icon: 'mdi-cash-multiple', to: '/inquilino/pagos', match: (p) => p.startsWith('/inquilino/pagos') },
  )
  if (!sections || sections.maintenanceRequests) {
    items.push({
      label: 'Mis solicitudes', short: 'Solicitudes', icon: 'mdi-wrench-outline',
      to: '/inquilino/solicitudes', match: (p) => p.startsWith('/inquilino/solicitudes'),
    })
  }
  return items
}

export const tenantAccountItem = {
  label: 'Mi cuenta', short: 'Cuenta', icon: 'mdi-account-circle-outline',
  to: '/inquilino/cuenta', match: (p) => p.startsWith('/inquilino/cuenta'),
}